<script setup lang="ts">
import { tagOptions } from "@/utils/customerSupportTicketTags";

interface Props {
  labelClasses: string;
  value?: string[];
}

defineProps<Props>();
</script>

<template>
  <FormKit
    type="dropdown"
    data-testid="tags-input"
    name="tags"
    label="Tag(s)"
    placeholder="- -"
    multiple
    :classes="{
      wrapper: 'flex gap-1.5 w-full max-w-full !mb-0',
      inner: 'grow min-w-0',
      truncationCount: 'bg-gray-400 rounded w-6',
      label: labelClasses,
      selectedIcon: 'text-primary',
    }"
    :options="tagOptions"
    :value="value"
  />
</template>
